import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../components/Headers/Header";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import React from "react";
import ClinicianPaymentForm from "../../../../components/Clinician/ClinicianPaymentForm";
import ClinicianPaymentTracker from "../../../../components/Clinician/ClinicianPaymentTracker";

const ClinicianProfilePage: React.FC = () => {
    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="Payment" />
                <IonRow id="profile" className="ion-justify-content-center">
                    <IonCol sizeSm="12" sizeMd="10">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Your Payment Method</IonCardTitle>
                            <IonCardContent>
                                <ClinicianPaymentForm />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
                <IonRow id="profile" className="ion-justify-content-center">
                    <IonCol sizeSm="12" sizeMd="10">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Previous Payments</IonCardTitle>
                            <IonCardContent>
                                <ClinicianPaymentTracker />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default ClinicianProfilePage;